<!--
 * @Author: yl 1871883713@qq.com
 * @Date: 2024-03-14 09:34:32
 * @LastEditors: yl 1871883713@qq.com
 * @LastEditTime: 2024-07-23 14:13:59
 * @Description: 
-->
<template>
	<div
		:class="[rolColor === 'white' ? 'white' : 'primary-color']"
		class="header"
	>
		<!-- 公司logo -->
		<section class="logo-box">
			<div class="logoIcon">
				<img
					src="https://openim-1309784708.cos.ap-shanghai.myqcloud.com/54e7a8602d610ac0afa50136bafbe61a.png"
					class="logo"
				/>
			</div>
		</section>
		<!-- 菜单栏 -->
		<section
			class="title-container"
			@click.stop
		>
			<div
				class="item"
				:class="tab.title === '产品中心' ? 'plug-unit' : tab.title === '解决方案' ? 'solution' : ''"
				v-for="tab in tabList"
				:key="tab.id"
				@click="onTab(tab)"
			>
				<div
					class="title-box"
					:class="{ active: tabActivate(tab) && tab.title !== '产品中心' && tab.title !== '解决方案' }"
				>
					<!-- 标题 -->
					<h6 class="title">
						{{ tab.title }}
            <span v-if="tab.title === '产品中心'" class="new-sign">New</span>
						<i
							v-if="tab.title === '产品中心'"
							class="el-icon-arrow-up"
							:class="[showProducts === true ? 'icon-down' : 'icon-up', tab.id === currentTab && showProducts === true ? 'active' : '']"
						></i>
						<i
							v-if="tab.title === '解决方案'"
							class="el-icon-arrow-up"
							:class="[showProgram === true ? 'icon-down' : 'icon-up', tab.id === currentTab && showProgram === true ? 'active' : '']"
						></i>
					</h6>
					<!-- 下划线 -->
					<div
						class="wavy-line firstLeft"
						v-show="tabActivate(tab) && ([2, 4, 6].includes(tab.number))"
					>
						<img
							:class="{
								firstWide: tab.number === 2,
								thirdWide: tab.number === 4,
								forthWide: tab.number === 6
							}"
							:src="
								tab.number === 2
									? 'https://static.bimcc.com/openim/2%E5%AD%97%E7%AC%A6%402x2007DD738560F82D16ED67A33D1C344A.png'
									: 'https://static.bimcc.com/openim/4%E5%AD%97%E7%AC%A6%402x6DEA0866C63BEF4E6EC3BED84EDA5251.png'
							"
							alt
						/>
					</div>
				</div>
			</div>
		</section>
		<!-- 登录，立即试用 -->
		<section
			class="use-box"
		>
			<div class="login">
				<el-button
					type="primary"
					class="button"
					@click="onJumpLogin()"
					>登 录</el-button
				>
			</div>
			<div class="use-button">
				<el-button
					type="primary"
					class="button"
					@click="onJumpLogin(1)"
					>注 册</el-button
				>
			</div>
		</section>
		<!-- 进入工作台 -->
		<!-- <section
			v-else
			class="avatar-box-home"
		>
			<div class="avatar-box">
				<img
					:src="userInfo.avatar || defaultAvatar"
					class="avatar-box-img"
				/>
			</div>
			<div class="use-button">
				<el-button
					type="primary"
					class="button"
					@click="onHome"
					>进入工作台</el-button
				>
			</div>
		</section> -->
		<!-- 屏幕宽度小于1340px时，按钮样式 -->
		<section class="loge-btn">
			<button
				v-if="!userInfo"
				class="button"
				@click="onJumpLogin()"
			>
				登录 / 注册
			</button>
		</section>
		<div class="menu">
			<!-- 产品 -->
			<MenuSelectItem
				:showBar="showProducts"
				:menuList="productsList"
				:cardsList="cardsList"
				:menuTitle="productTitle"
				@cancel="cancelProducts"
			></MenuSelectItem>
			<!-- 方案 -->
			<MenuSelectItem
				:showBar="showProgram"
				:menuTitle="programmeTitle"
				:menuList="programmeList"
				@cancel="cancelProgram"
			></MenuSelectItem>
		</div>
	</div>
</template>

<script>
import { Button } from 'element-ui';
import MenuSelectItem from '@/views/webPage/components/MenuSelectItem.vue';
import { getToken } from '@/utils/tools';
import { userInfo, tokenExpire } from '@/apis/saas';
import { mapState } from 'vuex';
import Cookies from 'js-cookie';
export default {
	name: 'HeadTabbar',
	components: {
		'el-button': Button,
		MenuSelectItem
	},
	props: {
		rollColor: {
			// tabbar颜色
			type: String,
			required: false,
			default: ''
		}
	},
	data() {
		return {
      frist:true,
			defaultAvatar: require('@/assets/images/Group.png'),
			userInfo: null,
			// 产品
			showProducts: false,
			// 方案
			showProgram: false,
			rolColor: '',
			clickColor: null,
			productTitle: [
				{
					id: 0,
					title: '飞椽零代码开发平台'
				},
				{
					id: 1,
					title: '飞椽能力家族'
				},
        // {
				// 	id: 2,
				// 	title: ''
				// },
				// {
				// 	id: 3,
				// 	title: '衍生产品'
				// }
			],
      cardsList: [
        {
          title: 'Saas 版',
          text: '轻量标准化业务助手',
          backgroundImage: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/c8c05a834cd6702cf0ba26ee092e5033.png',
          isNew: false,
          path: '/products/products-saas'
        },
        {
          title: '专业版',
          text: '融合集成化管理平台',
          backgroundImage: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/8f0cc50f55b70a85f6d0bdb1034a3046.png',
          isNew: true,
          path: '/products/professional-edition'
        }
      ],
			programmeTitle: [
				{
					id: 0,
					title: '场景筑云'
				},
				{
					id: 1,
					title: '平台解决方案'
				}
			],
			// 顶部tab配置
			tabList: [
				{
					id: 0,
					title: '首页',
					name: 'HomePage',
					icon: 'iconc-home',
					number: 2
				},
				{
					id: 1,
					title: '产品中心',
					name: 'HomePage',
					icon: 'icongaikuang1',
					number: 3
				},
				{
					id: 2,
					title: '解决方案',
					name: 'Programme',
					icon: 'iconfangan',
					number: 3
				},
				// {
				// 	id: 3,
				// 	title: '数字孪生',
				// 	name: 'DigitalTwin',
				// 	icon: 'iconshejibiangeng',
				// 	number: 4
				// },
				// {
				// 	id: 4,
				// 	title: '智慧工地',
				// 	name: 'WisdomSite',
				// 	icon: 'icona-zhihuijianguankeshihua',
				// 	number: 4
				// },
				{
					id: 5,
					title: '客户案例',
					name: 'CustomerCase',
					icon: 'iconfangan',
					number: 4
				},
				{
					id: 6,
					title: '价格体系',
					name: 'Price',
					icon: 'icona-jiagejine',
					number: 4
				},
				{
					id: 7,
					title: '应用市场',
					name: 'Template',
					icon: 'iconmobanguanli',
					number: 4
				},
				{
					id: 8,
					title: '飞椽课堂',
					name: 'ZhuyunCollege',
					icon: 'iconnav-jinchangjiaoyu',
					number: 4
				},
				{
					id: 9,
					title: '生态合作计划',
					name: 'CooperationPlan',
					icon: 'iconnav-jinchangjiaoyu',
					number: 6
				},
				{
					id: 10,
					title: '下载',
					name: 'DownApp',
					icon: 'iconwangpan-xiazai1x',
					number: 2
				},
				{
					id: 11,
					title: '关于我们',
					name: 'AboutUs',
					icon: 'iconwentihuibao',
					number: 4
				}
			],
			productsList: [
				{
					id: 0,
					title: '流程引擎',
					text: '跨组织审批，中国式审批流',
					icon: 'iconliuchengyinqing',
					hoverIcon: 'icona-liuchengyinqinghover',
					hover: 'pink',
					path: '/products/process-engine',
					show: false
				},
				{
					id: 1,
					title: 'BIMGIS数字孪生引擎',
					text: '提供从宏观到微观的模型应用能力',
					icon: 'iconshuziluanshengyinqing',
					hoverIcon: 'icona-shuziluanshengyinqinghover',
					hover: 'green',
					path: '/products/digital-twin',
					show: false
				},
				{
					id: 2,
					title: '数据表格引擎',
					text: '多类型工程行业复杂表格驱动',
					icon: 'iconshujubiaogeyinqing',
					hoverIcon: 'icona-shujubiaogeyinqinghover',
					hover: 'blue',
					path: '/products/data-table',
					show: false
				},
				{
					id: 3,
					title: '电子签名',
					text: '签名签章，更快更便捷',
					icon: 'icondianziqianming',
					hoverIcon: 'icona-dianziqianminghover',
					hover: 'purple',
					path: '/web-page/templates',
					show: false
				},
				{
					id: 4,
					title: '表单引擎',
					text: '多控件拖拉拽快速构建表单',
					icon: 'iconbiaodanyinqing',
					hover: 'yellow',
					hoverIcon: 'icona-biaodanyinqinghover',
					path: '/products/form-engine',
					show: false
				},
				{
					id: 5,
					title: '360°全景引擎',
					text: '施工现场实时低延时全景直播',
					icon: 'iconquanjingyinqing',
					hoverIcon: 'icona-quanjingyinqinghover',
					hover: 'blue',
					path: '/products/panorama',
					show: false
				},
				{
					id: 6,
					title: '任务自动化引擎',
					text: '多控件拖拉拽，所见即所得',
					icon: 'iconrenwuyinqing',
					hoverIcon: 'icona-renwuyinqinghover',
					hover: 'green',
					path: '/products/automation-engine',
					show: false
				},
				{
					id: 7,
					title: '自定义打印',
					text: '随你所设，随你定义',
					icon: 'icondayin',
					hoverIcon: 'icona-dayinhover',
					hover: 'yellow',
					path: '/web-page/templates',
					show: false
				},
				{
					id: 8,
					title: '无代码页面渲染引擎',
					text: '大屏 门户 APP UI设计完享自主设计',
					icon: 'iconwudaimayemianxuanran',
					hoverIcon: 'icona-wudaimayemianxuanranhover',
					hover: 'green',
					path: '/products/no-code',
					show: false
				},
				{
					id: 9,
					title: '元数据建模引擎',
					text: 'ER图快速创建元数据',
					icon: 'iconshujuyewujianmo',
					hoverIcon: 'icona-shujuyewujianmohover',
					hover: 'purple',
					path: '/products/data-modeling',
					show: false
				},
				{
					id: 10,
					title: '逻辑蓝图&ETL视图引擎',
					text: '事件逻辑编排&跨表数据聚合',
					icon: 'iconlantu',
					hoverIcon: 'icona-lantuhover',
					hover: 'yellow',
					path: '/products/blueprint',
					show: false
				},
				{
					id: 11,
					title: '四合一网络图',
					text: '甘特图、时标图、双待号、PERT图',
					icon: 'iconmoren1',
					hoverIcon: 'iconsiheyixuanting1',
					hover: 'blue',
					path: '/web-page/templates',
					show: false
				},
				{
					id: 12,
					title: 'PPT',
					text: '在线幻灯片，更多素材 ',
					icon: 'iconPPT',
					hoverIcon: 'icona-PPThover',
					hover: 'pink',
					path: '/products/slide',
					show: false
				},
				{
					id: 13,
					title: '页面编辑器',
					text: '2.0升级迭代，更易用',
					icon: 'iconyemianbianjiqi',
					hoverIcon: 'icona-yemianbianjiqihover',
					hover: 'blue',
					path: '/products/page-editor',
					show: false
				}
			],
			programmeList: [
				{
					id: 0,
					title: '基础能力',
					text: '多种内置基础库',
					icon: 'iconjichunengli',
					hoverIcon: 'icona-jichunenglihover',
					hover: 'pink',
					path: '/propramme/basic-abl',
					show: false
				},
				{
					id: 1,
					title: '安全环保管理',
					text: '巡检、班前会等多元一体',
					icon: 'iconanquanhuanbaoguanli',
					hoverIcon: 'icona-anquanhuanbaoguanlihover',
					hover: 'yellow',
					path: '/propramme/hse',
					show: false
				},
				{
					id: 2,
					title: '施工进度',
					text: '计划、实际一目了然',
					icon: 'iconshigongjindu',
					hoverIcon: 'icona-shigongjinduhover',
					hover: 'blue',
					path: '/propramme/wark-progress',
					show: false
				},
				{
					id: 3,
					title: '教育培训',
					text: '多维集成于互动教学平台',
					icon: 'iconjiaoyupeixun',
					hoverIcon: 'icona-jiaoyupeixunhover',
					hover: 'blue',
					path: '/propramme/edu-train',
					show: false
				},
				{
					id: 4,
					title: '安全教育',
					text: '培训学习高效资料输出',
					icon: 'iconanquanjiaoyu',
					hoverIcon: 'icona-anquanjiaoyuhover',
					hover: 'yellow',
					path: '/propramme/safe-edu',
					show: false
				},
				{
					id: 5,
					title: '质量管理',
					text: '数字化保障项目质量',
					icon: 'iconzhiliangguanli2',
					hoverIcon: 'icona-zhiliangguanlihover',
					hover: 'green',
					path: '/propramme/quality-manage',
					show: false
				},
				{
					id: 6,
					title: '智慧工地',
					text: '监测、预警一步到位',
					icon: 'iconzhihuigongdi1',
					hoverIcon: 'icona-zhihuigongdihover',
					hover: 'purple',
					path: '/propramme/smart-site',
					show: false
				},
				{
					id: 7,
					title: '工程行业方案',
					text: '多维集成于互动教学平台',
					icon: 'icongongchengjianzao',
					hoverIcon: 'icona-gongchengjianzaohover',
					hover: 'green',
					path: '/propramme/engineering',
					show: false
				},
				{
					id: 8,
					title: '设备管理',
					text: '全流程生命周期管理',
					icon: 'iconshebeixunjian',
					hoverIcon: 'icona-shebeixunjianhover',
					hover: 'green',
					path: '/propramme/device-manage',
					show: false
				},
				{
					id: 9,
					title: 'BIM GIS',
					text: '构件、模型互通联动',
					icon: 'iconbimgis',
					hoverIcon: 'icona-bimgishover',
					hover: 'blue',
					path: '/propramme/bim-gis',
					show: false
				},
				{
					id: 10,
					title: '疫情防控',
					text: '体温检测，防疫物资调度',
					icon: 'iconyiqingfangkong',
					hoverIcon: 'icona-yiqingfangkonghover',
					hover: 'yellow',
					path: '/propramme/epidemic',
					show: false
				},
				{
					id: 11,
					title: '数字资料档案管理',
					text: '工程项目实时数据资料采集记录 ',
					icon: 'iconshuziziliao1',
					hoverIcon: 'iconshuziziliaohover',
					hover: 'blue',
					path: '/propramme/digitalData',
					show: false
				},
        {
					id: 14,
					title: '数字孪生',
          text: '传递数据价值 ',
					icon: 'iconshujubiaogeyinqing',
					hoverIcon: 'icona-shujubiaogeyinqinghover',
					hover: 'blue',
					path: '/web-page/digital-twin'
				}
			],
			currentTab: 0,
			currentRoute: ''
		};
	},
	computed: {
		...mapState(['indexCurrentTab'])
	},
	watch: {
		rollColor: {
			handler(val) {
				this.rolColor = val;
			},
			immediate: true,
			deep: true
		},
		/**
		 * @desc: 监听产品和方案状态
		 */
		showProducts() {
			if (this.showProducts === false) {
				this.clickColor = null;
			} else {
				this.clickColor = 'white';
			}
		},
		showProgram() {
			if (this.showProgram === false) {
				this.clickColor = null;
			} else {
				this.clickColor = 'white';
			}
		},
		indexCurrentTab(val) {
			if (!location.href.includes('apply-demo')) {
				this.onTab(this.tabList.find(ele => +ele.id === +val));
			}
		},
		$route: {
			handler: function (route) {
				this.currentRoute = route.name;
			},
			immediate: true
		}
	},
	created() {},
	mounted() {
		document.addEventListener('click', this.bodyCloseMenus);
		if (!location.href.includes('?token=') && !location.href.includes('?clear')) {
			if (getToken()) {
				tokenExpire({ token: getToken() }).then(res => {
					if (res.data.data !== 1) {
						Cookies.set('bimcctoken', '');
						localStorage.setItem('userInfo', '');
						this.getData();
					}
				});
			}
		}
		if (location.href.includes('?clear')) {
			Cookies.set('bimcctoken', '');
			localStorage.setItem('userInfo', '');
		}
		if (location.href.includes('?token=')) {
			let token = location.href.split('token=')[1];
			Cookies.set('bimcctoken', token);
			userInfo(token).then(res => {
				localStorage.setItem('userInfo', JSON.stringify(res.data.data));
				this.getData();
			});
		} else {
			this.getData();
		}
	},
	beforeDestroy() {
		document.removeEventListener('click', this.bodyCloseMenus);
	},
	methods: {
		/**
		 * @desc: tab激活状态
		 */
		tabActivate(tab) {
			if (this.currentTab && this.currentTab === tab.id) {
				return true;
			} else {
				if (tab.name === this.currentRoute) {
					return true;
				}
			}
		},
		getData() {
			const indexCurrentTab = this.indexCurrentTab;
			if (!isNaN(+indexCurrentTab) && !location.href.includes('apply-demo')) {
				this.currentTab = +indexCurrentTab;
        if(!this.frist){
          this.onTab(this.tabList.find(ele => +ele.id === +this.currentTab));
        }else{
          this.frist = false;
        }
				
			}
			try {
				this.serverList = JSON.parse(localStorage.getItem('serverList')) || [];
			} catch (e) {
				console.log(e);
			}
			if (localStorage.getItem('userInfo')) {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
			}
		},
		/**
		 * @desc: 顶部栏有滚动条时变白
		 */
		cancelProducts(val) {
			if (val.indexOf('plug-unit') === -1) {
				this.showProducts = false;
			}
		},
		cancelProgram(val) {
			if (val.indexOf('solution') === -1) {
				this.showProgram = false;
			}
		},
		/**
		 * @desc: 点击菜单项，菜单项分情况
		 */
		onTab(tab) {
			this.currentTab = tab.id;
			if (tab.title === '解决方案') {
				this.rolColor = 'white';
				this.getProgram();
				return;
			} else if (tab.title === '产品中心') {
				this.rolColor = 'white';
				this.getProducts();
				return;
			} else {
				this.rolColor = '';
				this.showProducts = false;
				this.showProgram = false;
			}
			this.$store.commit('setIndexCurrentTab', +tab.id);
			/* 后台管理系统跳转到官网页面  携带prohibitFirstJump参数 禁止跳转官网其他页面  且只首次禁止 */
			if (this.$route.query && this.$route.query.prohibitFirstJump) {
				this.$router.replace({
					path: this.$route.path
				});
				return;
			}
			this.$router.replace({
				name: tab.name,
				query: this.$route.name === tab.name ? (this.$route.query ? this.$route.query : {}) : {}
			});
		},
		getProducts() {
			this.showProgram = false;
			this.showProducts = !this.showProducts;
		},
		getProgram() {
			this.showProgram = !this.showProgram;
			this.showProducts = false;
		},
		bodyCloseMenus() {
			if (this.showProducts == true) {
				this.showProducts = false;
			}
			if (this.showProgram == true) {
				this.showProgram = false;
			}
		},

		onJumpLogin(type) {
			if (type) {
				window.location.href = 'https://newsaas.bimcc.com/login?index=1';
			} else {
				window.location.href = 'https://newsaas.bimcc.com/login';
			}
		},
		onHome() {
			window.location.href = 'https://newsaas.bimcc.com/login';
		}
	}
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1601px) {
	.loge-btn {
		display: none;
	}
}
@media screen and (max-width: 1600px) {
	.text-logo {
		display: none;
	}
	.webPage-menu .header .use-box {
		display: none;
	}
	.loge-btn {
		.button {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 108px;
			height: 36px;
			border: 1.5px solid rgb(51, 112, 255);
			background-color: transparent;
			color: rgb(51, 112, 255);
			font-size: 14px;
			border-radius: 6px;
		}
	}
}
@media screen and (max-width: 1261px) {
	.webPage-menu .header-menu .header .logo-box {
		padding-right: 0px;
		box-sizing: border-box;
	}
	.item {
		padding: 0 15px;
		box-sizing: border-box;
	}
}
.active {
	color: #337eff;
}
.firstWide {
	width: 34px;
}
.thirdWide {
	width: 64px;
}
.forthWide {
  width: 84px;
}
.firstLeft {
	left: 29%;
}
.primary-color {
	background-color: transparent;
	animation-name: hideBackground;
	animation-duration: 0.5s;
	animation-iteration-count: 1;
	@keyframes hideBackground {
		0% {
			background-color: #fff;
		}
		100% {
			background-color: transparent;
		}
	}
}
.white {
	background-color: #fff;
	animation-name: changeBackground;
	animation-duration: 0.5s;
	animation-iteration-count: 1;
	@keyframes changeBackground {
		0% {
			background-color: transparent;
		}
		100% {
			background-color: #fff;
		}
	}
}
.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: 64px;
	padding: 0 30px;
	box-sizing: border-box;
	z-index: 999;
	.logo-box {
		display: flex;
		align-items: center;
		.logoIcon {
			height: 46px;
			width: 103px;
			box-sizing: border-box;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.text-logo {
			width: 100%;
			img {
				width: 100%;
			}
		}
	}
	.title-container {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 1200px;
		height: 100%;
		padding: 0 0px;
		box-sizing: border-box;
		.item {
			display: flex;
			flex-direction: column;
			align-items: center;
			position: relative;
			width: auto;
			height: auto;
			padding: 0 20px;
			box-sizing: border-box;
			white-space: nowrap;
			cursor: pointer;

			.title-box {
				width: auto;
				height: 64px;
				padding: 10px 0;
				box-sizing: border-box;
				.title {
          display: flex;
          align-items: center;
          position: relative;
					height: 30px;
					line-height: 40px;
					font-size: 14px;
					font-weight: 600;
          .new-sign {
            display: inline-flex;
            height: 14px;
            margin: 0 6px;
            padding: 0px 4px;
            justify-content: center;
            align-items: flex-start;
            flex-shrink: 0;
            border-radius: 4px;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%), var(--semantic-error-background-variant, #FC5558);
            box-shadow: 0px 0.5px 1px 0px rgba(252, 85, 88, 0.24), 0px 1px 2px 0px rgba(252, 85, 88, 0.12), 0px 0.5px 3px 0px rgba(252, 85, 88, 0.12);
            color: #FFF4F4;
            font-family: "Helvetica Neue";
            font-size: 10px;
            font-style: italic;
            font-weight: 500;
            line-height: 14px;
            letter-spacing: 0.5px;
          }
					i {
						font-weight: bold;
					}
					.icon-down {
						transition-duration: 0.3s;
					}
					.icon-up {
						transform: rotate(180deg);
						transition-duration: 0.3s;
					}
				}
			}
		}
	}
	.use-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		min-width: 130px;
		min-height: 64px;
		.login {
			.button {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 78px;
				height: 38px;
				border: 1.5px solid rgb(51, 112, 255);
				background-color: transparent;
				color: rgb(51, 112, 255);
				font-size: 14px;
				border-radius: 6px;
			}
			.titleText {
				min-width: 33px;
				min-height: 20px;
				font-size: 14px;
				font-weight: bold;
				white-space: nowrap;
			}
		}
		.use-button {
			padding-left: 15px;
			box-sizing: border-box;
			.button {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 78px;
				height: 38px;
				background-color: rgb(51, 112, 255);
				color: #fff;
				font-size: 14px;
				border-radius: 6px;
			}
		}
	}
	.avatar-box-home {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 171px;
		.button {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 38px;
			border: 1.5px solid rgb(51, 112, 255);
			background-color: transparent;
			color: rgb(51, 112, 255);
			font-size: 14px;
			border-radius: 6px;
		}
		.avatar-box {
			height: 40px;
			width: 40px;
			.avatar-box-img {
				height: 100%;
				width: 100%;
				border-radius: 50%;
				margin-right: 0;
				border: 2px solid rgb(212, 212, 212);
			}
		}
	}
	.menu {
		position: fixed;
		top: 64px;
		left: 0;
		right: 0;
		width: 100%;
		z-index: 9998;
	}
}
@keyframes showBorder {
	0% {
		width: 0;
	}
	100% {
		width: 100%;
	}
}
</style>
